// An elephant, modelled facing +X: a massive grey body on pillar legs, big
// flapping ears, a curling trunk and tusks. Ported 1:1 from age-of-mcp's classic
// elephant.ts, restoring its leg loop + body/head/ear/trunk/tusk composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.11, 0.08], [0.11, -0.08], [-0.11, 0.08], [-0.11, -0.08]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.03, 0.028, 0.24, 6),
      color: "#8c8c90", position: [x!, 0.12, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#9a9a9e",
      position: [0, 0.24, 0], scale: [1.6, 1.1, 1.15] },             // body
    { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#a2a2a6",
      position: [0.22, 0.26, 0], scale: [1, 1, 1] },                 // head
    { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#8e8e92",
      position: [0.2, 0.25, 0.12], scale: [0.3, 1.3, 1.1] },         // ear
    { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#8e8e92",
      position: [0.2, 0.25, -0.12], scale: [0.3, 1.3, 1.1] },
    // Trunk — a few tapering segments curving down and forward.
    { geometry: new THREE.CylinderGeometry(0.028, 0.022, 0.1, 5), color: "#9a9a9e",
      position: [0.31, 0.21, 0], rotation: [0, 0, 0.4] },
    { geometry: new THREE.CylinderGeometry(0.02, 0.014, 0.09, 5), color: "#9a9a9e",
      position: [0.35, 0.12, 0], rotation: [0, 0, 1.0] },
    { geometry: new THREE.ConeGeometry(0.012, 0.07, 4), color: "#e8e2d0",
      position: [0.32, 0.18, 0.05], rotation: [0, 0, -2.4] },        // tusk
    { geometry: new THREE.ConeGeometry(0.012, 0.07, 4), color: "#e8e2d0",
      position: [0.32, 0.18, -0.05], rotation: [0, 0, -2.4] },
  );
  return parts;
}

export const elephant = defineModel({
  id: "elephant",
  scale: 3.22, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Elephant",
  tags: ["creature","elephant","low-poly","age-of-mcp","classic"],
  summary: "Low-poly elephant.",
  front: "+x",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.3,
  fits: ["draft"],
  parts: () => partsFor(),
  animations: [],
});
